<div class="hood-settings-container">
  <div class="cf-flex-column group-layout">
    <div class="mat-headline-6">{{ 'UI.HoodAirflowAndDimensions' | translate }}</div>
    <div class="cf-flex-row cf-flex-wrap">
      <ng-container *ngFor="let item of propertyItems$ | async">
        <div class="property-layout form-field-property cf-flex-column cf-flex-1">
          <div class="cf-flex-column cf-flex-1">
            <label class="ac-form-field-label ac-form-field-label-disabled ac-form-field-label-readonly">
              <span>{{ item.propertyType.NameId ? (item.propertyType.NameId | translate) : item.property.Key }}</span>
            </label>
            <mat-form-field
              [attr.data-test]="item.propertyType.Key"
              class="cf-flex"
              appearance="outline"
              subscriptSizing="dynamic"
              [disabled]="true"
            >
              <input
                matInput
                appNumberInput
                [localeCode]="localeCode$ | async"
                [disabled]="true"
                [numberFormControl]="item.formControl"
                [numberOfDecimals]="item.property?.MeasurementUnit?.Decimals"
                type="text"
                inputmode="numeric"
                [placeholder]="placeholder"
                (focus)="focused = true"
                (blur)="focused = false"
              />
              <span matTextSuffix *ngIf="item.measurementUnit">{{ item.measurementUnit?.TextId | translate }}</span>
            </mat-form-field>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
